export enum BillTypeEnum {
    First_FortNight = 'First Fortnight',
    Final_FortNight = 'Final Fortnight',
    
}

export enum ContractorTypeEnum {
    local = 'Local',
    non_local = 'Non Local',
    
}